<template>
  <div class="textarea-input">
    <textarea
      :value="value"
      class="input"
      :placeholder="placeholder"
      @input="
        event => {
          $emit('changedValue', event.target.value);
        }
      "
    />
    <div v-if="maxLength" class="textarea-input__counter">
      <span class="textarea-input__length">{{ length }}</span> /
      <span class="textarea-input__max-count">{{ maxLength }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number
    }
  },
  computed: {
    length() {
      return this.value.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea-input {
  position: relative;
  padding-bottom: 24px;
  background: #f7f7fb;

  &__counter {
    position: absolute;
    right: 14px;
    bottom: 8px;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.3px;
    color: #898989;
  }
}
textarea::placeholder {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.3px;
  color: #76767b;
}
textarea {
  font-family: 'Helvetica', sans-serif;
  resize: none;
  padding: 16px 14px 0;
  width: 100%;
  border: none;
  background: transparent;
}
</style>
